__webpack_require__.p = "https://bundle.stayforlong.com/20260127.6/_next/";